import React from "react";

const items = [
  "React", "FastAPI", "MongoDB", "OpenAI", "Claude", "Gemini", "LLM Agents",
  "Stripe", "Realtime", "Auth", "Cloud Deploy", "Mobile", "RAG", "Vector DB",
];

export default function Marquee() {
  return (
    <div className="relative border-y border-white/10 bg-surface/30 py-4 overflow-hidden">
      <div className="flex w-max animate-marquee">
        {[...items, ...items].map((t, i) => (
          <span
            key={i}
            className="mx-6 font-mono text-sm uppercase tracking-widest text-white/40 whitespace-nowrap"
          >
            {t} <span className="text-neon-cyan/50">/</span>
          </span>
        ))}
      </div>
    </div>
  );
}
